module.exports = __webpack_public_path__ + "static/media/GjLogo.0841e17d.svg";